module.exports = __webpack_public_path__ + "static/media/paperclip.110d99f0.svg";